import React, {useCallback, useEffect} from "react"
import { Form, Button, Alert } from 'react-bootstrap'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useForm, FormProvider } from 'react-hook-form'
import Majors from '../Majors'
import { navigate } from "@reach/router"
import CandidatesApi from "../../api/CandidatesApi"
import { ApiException, ExpiredSessionException, ValidationException } from "../../api/exceptions"
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import { connect } from "react-redux"

const StudentForm = ({ studentData, showOnSubmit = false, handleExpiredAuthState }) => {

  const recordExists = useCallback(() => (!!studentData?.inscripcion?.numero_de_control), [studentData?.inscripcion?.numero_de_control]);

  /** return serialized data object to set up as default when is update form */
  const serializeData = () => {
    if( studentData && Object.keys(studentData).length ){
      const { nombre, primer_apellido, segundo_apellido, correo, inscripcion: { carrera: { id: carrera_id }}, telefono_celular, curp, inscripcion: { numero_de_control, referencia, traslado, nip },} = studentData
      return {
        nombre,
        primer_apellido,
        segundo_apellido,
        correo,
        carrera_id,
        telefono_celular,
        curp,
        numero_de_control,
        referencia,
        traslado,
        nip
      }
    }
  }
  const formMethods = useForm()
  const { register, handleSubmit, formState: { errors }, reset, setFocus } = formMethods

  const alert = withReactContent(Swal)
  
  const onSubmit = data => {
    const api = new CandidatesApi();

    (recordExists() ? api.update(studentData.inscripcion.numero_de_control, data) : api.store(data))
      .then( response => {
        alert.fire({
            title: 'Exito',
            text: 'El alumno se dio de alta correctamente',
            icon: 'success',
            onAfterClose: () => {
              if (!showOnSubmit) {
                reset({})
                window.scrollTo(0,0)
                setFocus('nombre');
              }
            }
          })

          if (showOnSubmit) {
            window.scrollTo(0,0)
            navigate(`/admin/documentos/${data.numero_de_control}`)
          }
        })
      .catch( error => {
        if (error instanceof ExpiredSessionException) {
          return handleExpiredAuthState();
        }

        let message = 'Hubo un error al enviar la solicitud al servidor.';

        if (error instanceof ValidationException) {
          message = Object.values(error.errors).join(' \n');
        } else if (error instanceof ApiException) {
          message = error.message;
        }

        alert.fire({
          title: 'Error',
          text: message,
          icon: 'error'
        })
      })
  }

  useEffect( () => {
    window.scrollTo(0, 0)
    /** set data when is update form */
    reset(serializeData())
  }, [studentData])

  return (
    <FormProvider {...formMethods}>
      
        <Form onSubmit={handleSubmit(onSubmit)} >
          <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                  id="nombre"
                  type="text"
                  autoFocus
                  {...register('nombre', {
                    required: true
                  })}
              />
              {errors.nombre && <Alert variant='danger' className='mt-2'>Nombre es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>Apellido Paterno</Form.Label>
              <Form.Control
                  id="primer_apellido"
                  type="text"
                  {...register('primer_apellido', {
                    required: true
                  })}
              />
              {errors.primer_apellido && <Alert variant='danger' className='mt-2'>Apellido Paterno es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>Apellido Materno</Form.Label>
              <Form.Control
                  id="segundo_apellido"
                  type="text"
                  {...register('segundo_apellido', {
                    required: true
                  })}
              />
              {errors.segundo_apellido && <Alert variant='danger' className='mt-2'>Apellido Materno es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>Carrera</Form.Label>
              <Majors />
              {errors.carrera_id && <Alert variant='danger' className='mt-2'>Carrera es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>Correo</Form.Label>
              <Form.Control
                  id="correo"
                  type="email" 
                  {...register('correo', { required: true })}
              />
              {errors.correo && <Alert variant='danger' className='mt-2'>Correo es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>Teléfono</Form.Label>
              <Form.Control 
                  id="telefono_celular"
                  type="phone" 
                  {...register('telefono_celular', { required: true })}
              />
              {errors.telefono_celular && <Alert variant='danger' className='mt-2'>Celular es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>CURP</Form.Label>
              <Form.Control 
                  id="curp"
                  type="text"
                  {...register('curp', { required: true })}  
                />
              {errors.curp && <Alert variant='danger' className='mt-2'>Curp es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>N&uacute;mero de control</Form.Label>
              <Form.Control 
                  id="numero_de_control"
                  type="text"
                  {...register('numero_de_control', { required: true })}
              />
              {errors.numero_de_control && <Alert variant='danger' className='mt-2'>Núnero de control es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Label>Grupo</Form.Label>
              <Form.Control 
                  id="referencia"
                  type="text"
                  {...register('referencia', { required: true })} 
              />
              {errors.referencia && <Alert variant='danger' className='mt-2'>Grupo es requerido</Alert>}
          </Form.Group>
          <Form.Group>
              <Form.Check 
                type="switch"
                id="traslado"
                label="Traslado"
                {...register('traslado')}
              />
          </Form.Group>
          <Form.Group>
              <Form.Check 
                type="switch"
                id="equivalencia"
                label="Equivalencia"
                {...register('equivalencia')}
              />
          </Form.Group>
          <Form.Group>
              <Form.Label>NIP</Form.Label>
              <Form.Control 
                  id="nip"
                  type="text"
                  {...register('nip', { required: true })} 
              />
              {errors.nip && <Alert variant='danger' className='mt-2'>NIP es requerido</Alert>}
          </Form.Group>
          <Button type='submit' variant="primary">
              Guardar
          </Button>
      </Form>

    </FormProvider>  
  )
}

export default connect(null, {handleExpiredAuthState})(StudentForm)
